import { CircularProgress, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CurrencyInput from 'react-currency-input-field';
import '../../../scss/UVP.scss';
import { CustomerVService, TokenType } from '../../../services/V2/gozer';
import { UsersVService } from '../../../services/V2/keymaster';
import { checkPaymentAmount, handleErrorToast } from '../../shared/Functions';
import { Terminal } from '../Terminal';
import { I3PayFacFrame } from '../wallet/I3PayFacFrame';
import { TokensVService } from '../../../services/V3/gozer';
import { TerminalService } from '../../../services/TerminalService';

export const PaymentFlowPage1 = ({
    successToast,
    errorToast,
    district,
    billingAccount,
    paymentConfigs,
    tokens,
    paymentToken,
    setPaymentToken,
    cancel,
    amount,
    setAmount,
    selectedTab,
    setSelectedTab,
    hasError,
    setHasError,
    paymentMode,
    setPaymentMode,
    setNewPaymentMain,
    newEmail,
    setEmail,
    setTerminalResult,
}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [nextDisabled, setNextDisabled] = useState<boolean>(true);
    const [terminalId, setTerminalId] = useState<any>();
    const [errorMessage, setErrorMessage] = useState<any>(null);
    const [terminalDisabled, setTerminalDisabled] = useState<boolean>(true);
    const [serviceAddress, setServiceAddress] = useState<any>();
    const [newPayment, setNewPayment] = useState<any>({
        ach: false,
        cc: false,
        terminal: false
    });

    useEffect(() => {
        let accountServices = billingAccount?.services
        let servicesWithAddress = accountServices.filter(x => x?.serviceAddress && x?.serviceAddress !== "")
        if (servicesWithAddress.length > 0) {
            setServiceAddress(servicesWithAddress[0]?.serviceAddress)
        }
    }, [billingAccount])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if ((selectedTab === 0 && !hasError && !newPayment?.ach && !newPayment?.cc && (paymentToken?.id || terminalId)) || selectedTab !== 0)
            setNextDisabled(false);
        else setNextDisabled(true);
    }, [paymentToken, terminalId, newPayment, hasError])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        checkPaymentAmount(amount, paymentMode,
            paymentConfigs?.cc.maxAmount, paymentConfigs?.cc.minAmount,
            paymentConfigs?.ach.maxAmount, paymentConfigs?.ach.minAmount,
            setHasError, setErrorMessage);
    }, [amount, paymentConfigs, paymentMode])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (paymentToken?.id === "CCTerminal" || paymentToken?.tokenType === "CC") {
            setPaymentMode("CC")
        }
        else if (paymentToken?.id === "ACH" || paymentToken?.tokenType === "ACH") {
            setPaymentMode("ACH")
        }
        else {
            setPaymentMode(null)
        }
    }, [paymentToken])// eslint-disable-line react-hooks/exhaustive-deps

    const next = () => {
        if (newEmail) {
            if (billingAccount?.user) {
                setLoading(true)
                UsersVService.usersVUpdateUser(billingAccount.user.id, { email: newEmail })
                    .then(x => {
                        successToast("Successfully added email")
                        setLoading(false)
                    })
                    .catch(x => {
                        errorToast(handleErrorToast(x))
                        setLoading(false)
                    })
            } else {
                setLoading(true)
                CustomerVService.customerVUpdate(billingAccount.id, billingAccount.customer.id, { email: newEmail })
                    .then(x => {
                        successToast("Successfully added email")
                        setLoading(false)
                    })
                    .catch(x => {
                        errorToast(handleErrorToast(x))
                        setLoading(false)
                    })
            }
        }
        if (newPayment?.terminal) {
            setLoading(true)
            TerminalService.transactionsVTerminalTransaction(billingAccount.id, {
                terminalId: terminalId,
                amount: amount
            })
                .then(r => {
                    setSelectedTab(selectedTab + 2)
                    setLoading(false)
                    setTerminalResult(r)
                    setTerminalDisabled(false)
                })
                .catch(err => {
                    setLoading(false)
                    errorToast(handleErrorToast(err))
                });
        } else {
            setSelectedTab(selectedTab + 1)
        }
    }
    const saveToken = (success) => {
        if (!success) {
            setNewPayment({
                terminal: false,
                cc: false,
                ach: false
            })
            setPaymentToken({ id: "" })
        } else {
            setPaymentToken(success)
            setSelectedTab(selectedTab + 1)
        }
    }

    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={5} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", marginLeft: "20px" }}>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "20px" }}>
                            <b>Account</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' type="text" defaultValue={billingAccount?.accountNumber} disabled={true} style={{ width: "250px" }} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "10px" }}>
                            <b>Name</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' type="text" defaultValue={billingAccount?.customer.fullName} disabled={true} style={{ width: "250px" }} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "10px" }}>
                            <b>Service Address</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' type="text" defaultValue={serviceAddress?.street} disabled={true} style={{ width: "250px" }} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "10px" }}>
                            <b>City</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' type="text" defaultValue={serviceAddress?.city} disabled={true} style={{ width: "250px" }} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "10px" }}>
                            <b>State</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' type="text" defaultValue={serviceAddress?.state} disabled={true} style={{ width: "103px" }} />
                        </label>
                        <label className='uvp-label' style={{ marginTop: "10px", marginLeft: "10px" }}>
                            <b>Zip</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' type="text" defaultValue={serviceAddress?.zip} disabled={true} style={{ width: "104px" }} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "10px" }}>
                            <b>Payment Amount</b><span>&nbsp;:&nbsp;</span>
                            <CurrencyInput
                                id="paymentAmount"
                                className='uvp-input'
                                style={{ width: "250px" }}
                                prefix="$"
                                decimalScale={2}
                                value={amount}
                                onValueChange={(e, m, floatValue) => setAmount(floatValue?.value)} />
                            {errorMessage && errorMessage !== "" &&
                                <div className='error' style={{ textAlign: "right" }}>
                                    {errorMessage}
                                </div>
                            }
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "10px" }}>
                            <b>Receipt Delivery Email</b><span>&nbsp;:&nbsp;</span>
                            <input
                                className='uvp-input'
                                type="text"
                                defaultValue={billingAccount?.customer?.email ?? newEmail}
                                disabled={billingAccount?.customer?.email}
                                onChange={e => setEmail(e.target.value)}
                                style={{ width: "250px" }} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "10px" }}>
                            <b>Payment Method</b><span>&nbsp;:&nbsp;</span>
                            <select
                                className='uvp-select'
                                value={paymentToken?.id ?? ""}
                                onChange={e => {
                                    if (e.target.value === "CCTerminal") {
                                        setNewPayment({
                                            terminal: true,
                                            cc: false,
                                            ach: false
                                        })
                                        setNewPaymentMain({
                                            terminal: true,
                                            cc: false,
                                            ach: false
                                        })
                                        setTerminalId(null)
                                        setPaymentToken({ id: "CCTerminal" })
                                    } else if (e.target.value === "CC") {
                                        setNewPayment({
                                            terminal: false,
                                            cc: true,
                                            ach: false
                                        })
                                        setNewPaymentMain({
                                            terminal: false,
                                            cc: true,
                                            ach: false
                                        })
                                        setTerminalId(null)
                                        setPaymentToken({ id: "CC" })
                                    } else if (e.target.value === "ACH") {
                                        setNewPayment({
                                            terminal: false,
                                            cc: false,
                                            ach: true
                                        })
                                        setNewPaymentMain({
                                            terminal: false,
                                            cc: false,
                                            ach: true
                                        })
                                        setTerminalId(null)
                                        setPaymentToken({ id: "ACH" })
                                    } else {
                                        setPaymentToken(tokens.find(x => x.id === e.target.value))
                                        setNewPayment({
                                            terminal: false,
                                            cc: false,
                                            ach: false
                                        })
                                        setNewPaymentMain({
                                            terminal: false,
                                            cc: false,
                                            ach: false
                                        })
                                    }
                                }}
                                style={{ width: "250px", padding: "1px 2px", border: "2px inset lightdark" }}>
                                <option value="">Select Method</option>
                                {tokens?.map(x => (
                                    <option value={x.id} key={x.id}>
                                        {`${x?.tokenType === TokenType.CC ?
                                            x?.cardType :
                                            `${x?.achAccountHolderType} ${x?.achType}`} ****${x?.last4}`}
                                    </option>
                                ))}
                                {!billingAccount?.disallowCCPayments && paymentConfigs?.cc?.allowPayment && (
                                    <option value="CCTerminal">
                                        Credit Card Terminal
                                    </option>
                                )}
                                {!billingAccount?.disallowCCPayments && paymentConfigs?.cc?.allowPayment && (
                                    <option value="CC">
                                        Credit Card Entry
                                    </option>
                                )}
                                {!billingAccount?.disallowACHPayments && paymentConfigs?.ach?.allowPayment && (
                                    <option value="ACH">
                                        ACH Entry
                                    </option>
                                )}
                            </select>
                        </label>
                    </div>
                    <Grid container style={{ marginTop: "15px" }}>
                        <Grid item xs={12} style={{ marginLeft: "185px" }}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                {billingAccount?.disallowCCPayments && (
                                    <>
                                        {/* CC Radio Message */}
                                        <div className='uvp-label' style={{ color: "red", marginLeft: "5px" }}>
                                            Do Not Accept Credit Card
                                        </div>
                                    </>
                                )}
                                {billingAccount?.disallowACHPayments && (
                                    <>
                                        {/* ACH Radio Message */}
                                        <div className='uvp-label' style={{ color: "red", marginLeft: "5px" }}>
                                            Do Not Accept ACH/Check
                                        </div>
                                    </>
                                )}
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    {newPayment?.ach ?
                        <I3PayFacFrame
                            urlEndpoint={TokensVService.tokensVGetAchUrl}
                            billingAccountId={billingAccount.id}
                            getTokenEndpoint={TokensVService.tokensVCreateAch}
                            complete={saveToken}
                            errorToast={errorToast} /> :
                    newPayment?.terminal ?
                        <Terminal
                            operatorId={district.operatorId}
                            setTerminalId={setTerminalId}
                            districtId={district.id} /> :
                    newPayment?.cc ?
                        <I3PayFacFrame
                            urlEndpoint={TokensVService.tokensVGetCcUrl}
                            billingAccountId={billingAccount.id}
                            getTokenEndpoint={TokensVService.tokensVCreateCc}
                            complete={saveToken}
                            errorToast={errorToast} /> : <></>}
                    {newPayment?.terminal &&
                        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end", flexDirection: "column", marginTop: "50px" }}>
                            <button onClick={next} disabled={nextDisabled || !terminalDisabled} className={"green-button uvp-button"}
                                style={{
                                    minWidth: "245px",
                                    display: "block"
                                }}>
                                Initialize Terminal
                            </button>
                        </div>
                    }
                </Grid>
                <Grid container>
                    <Grid item xs={12} style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end", margin: "0px 0px 40px 100px" }}>
                        <Grid item xs={4} style={{ marginLeft: "20px" }}>
                            <button onClick={async () => cancel()} className={"gray-button"}
                                style={{
                                    margin: "5px",
                                    marginLeft: newPayment?.terminal ? "140px" : "5px",
                                    minWidth: "120px",
                                    borderRadius: "3px",
                                    border: "none",
                                    padding: "7px 15px",
                                    fontSize: "14px"
                                }}>
                                Cancel
                            </button>
                            {!newPayment?.terminal &&
                                <button onClick={next} disabled={nextDisabled} className={"green-button uvp-button"}
                                    style={{
                                        minWidth: "120px"
                                    }}>
                                    Next
                                </button>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {loading &&
                <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
            }
        </React.Fragment>
    )
}